/* countdown.js — drives [data-countdown] timers. Framework-free, deferred. */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick(el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return null;
    var diff = target - Date.now();
    if (diff <= 0) {
      el.classList.add('is-expired');
      var timer = el.querySelector('[data-countdown-timer]');
      if (timer && !el.querySelector('.countdown__expired')) {
        var msg = document.createElement('span');
        msg.className = 'countdown__expired';
        msg.textContent = el.getAttribute('data-expired') || '';
        el.appendChild(msg);
      }
      return false;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var set = function (sel, val) { var n = el.querySelector(sel); if (n) n.textContent = val; };
    set('[data-cd-days]', d);
    set('[data-cd-hours]', pad(h));
    set('[data-cd-min]', pad(m));
    set('[data-cd-sec]', pad(s));
    return true;
  }

  function init() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (tick(el) === false) return;
      var id = setInterval(function () { if (tick(el) === false) clearInterval(id); }, 1000);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
